// source: types/v1/lesson_content_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.types.v1.LessonContentType', null, global);
/**
 * @enum {number}
 */
proto.types.v1.LessonContentType = {
  LESSON_CONTENT_TYPE_UNSPECIFIED: 0,
  LESSON_CONTENT_TYPE_BOOK: 1,
  LESSON_CONTENT_TYPE_SUMMARY: 2
};

goog.object.extend(exports, proto.types.v1);
